import store from '@/store';
import pixNProgress from '@/shared/pixNProgress.js';
import mandateGuard from '@/guards/mandate/mandate.guard.js';

export default async (to, from, next) => {
  try {
    await store.dispatch('mandatePropertyModule/setPropertiesListFilters', '');
    await store.dispatch('mandatePropertyModule/resetPagination');
    await store.dispatch('mandatePropertyModule/fetchPropertiesList', to.params.mandateId);
    mandateGuard(to, from, next);
    next();
  } catch (error) {
    store.dispatch('toastModule/error', 'Error loading properties');
    pixNProgress.forceFinish();
    next(false);
  }
};
